export const legalTranslations = {
  title: "Mentions légales",
  description: "Mentions légales et informations sur la société Leadsme. Coordonnées, SIREN, hébergement et responsabilité éditoriale.",
  content: `1. Éditeur du site
Le site Leadsme est édité par :
- Nom et prénom : DUHR Romain
- Statut : Entrepreneur individuel (EI)
- Nom commercial : Leadsme

2. Adresse
Adresse du siège / domicile professionnel :
- 220B rue du Buisson, 59700 Marcq-en-Barœul, France

3. Contact
Adresse email : contact@leadsme.app
Formulaire de contact : accessible via la page de contact du site

4. Immatriculation
SIREN : 889 784 864

5. TVA
TVA non applicable, article 293B du Code général des impôts.

6. Directeur de la publication
DUHR Romain, en qualité d'éditeur du site Leadsme.

7. Hébergement
Le site est hébergé par :
- Hébergeur : Amazon Web Services (AWS)
- Région : eu-west-3 (Paris)
- Site web : https://aws.amazon.com`,
  lastUpdate: "9 janvier 2026",
} as const;